import { render, staticRenderFns } from "./insertElements.vue?vue&type=template&id=7c96e495&scoped=true"
import script from "./insertElements.vue?vue&type=script&lang=js"
export * from "./insertElements.vue?vue&type=script&lang=js"
import style0 from "./insertElements.vue?vue&type=style&index=0&id=7c96e495&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c96e495",
  null
  
)

export default component.exports